<template>
  <div class="content">
    <div class="content__wrapper--contact">
      <div class="content__title">
        <h1 class="text-mturquoise">{{ title }}</h1>
      </div>

      <div class="content__text w-full font-normal">
        <p>
          Contactez-nous ou venez nous rencontrer pour découvrir « le service
          Corbet », un atout pour vos projets :
        </p>
        <ul class="list-disc list-inside">
          <li>votre satisfaction, votre confiance, votre sécurité,</li>
          <li>
            notre expertise métier, notre conseil proactif, notre réactivité,
            notre respect des délais, notre disponibilité,
          </li>
          <li>le sourire de notre équipe,</li>
        </ul>
      </div>

      <div class="contact">
        <div
          v-for="contact in contacts"
          :key="contact.name"
          class="contact__single"
        >
          <ul class="contact__list">
            <li>
              <span class="noIcon font-bold">{{ contact.name }}</span>
            </li>
            <li>
              <img class="contact-icon" src="static/icons/phone-icon.png" /><a
                class="contact__details"
                :href="contact.phoneLink"
                >{{ contact.phone }}</a
              >
            </li>
            <li>
              <img class="contact-icon" src="static/icons/mail-icon.png" /><a
                class="mail-link inline-block"
                :href="'mailto:' + contact.mail"
                ><img class="contact__details--img" :src="contact.imgMail"
              /></a>
            </li>
          </ul>
        </div>
      </div>

      <p>
        Si vous souhaitez nous rendre visite, nous sommes basée à proximité
        d’Orléans, dans le Loiret (région Centre-Val de Loire), entre Paris et
        Tours.
      </p>

      <div
        class="location flex flex-col flex-wrap md:items-center md:flex-row md:flex-nowrap w-full justify-between mt-10"
      >
        <div class="location__item locationInfos flex flex-col">
<!--          <div class="locationInfos__item">-->
<!--            <ul>-->
<!--              <li><span class="noIcon font-bold">ACCUEIL</span></li>-->
<!--              <li>-->
<!--                <img-->
<!--                  class="contact-icon"-->
<!--                  src="static/icons/phone-icon.png"-->
<!--                /><span class="contact__details">02 38 63 44 40</span>-->
<!--              </li>-->
<!--              <li>-->
<!--                <img class="contact-icon" src="static/icons/mail-icon.png" /><a-->
<!--                  class="mail-link inline-block"-->
<!--                  href="mailto:contact@corbet-com.fr"-->
<!--                  ><img-->
<!--                    class="contact__details&#45;&#45;img"-->
<!--                    src="/static/contacts/contact.png"-->
<!--                /></a>-->
<!--              </li>-->
<!--            </ul>-->
<!--          </div>-->

          <div class="locationInfos__item md:pl-10 text-center font-normal">
            <p class="my-0 font-bold">Horaires d'ouverture :</p>
            <ul>
              <li>8h30 - 17h00</li>
              <li>Sans Interruption</li>
            </ul>
          </div>

          <div
            class="locationInfos__item--full flex md:pl-10"
          >
            <div class="location-icon flex justify-center items-center">
              <img src="static/icons/location-icon.png" />
            </div>

            <div class="mt-0 font-bold text-left">
              <ul>
                <li>SAS CORBET</li>
                <li>Zac, les provinces</li>
                <li>21, rue de Picardie</li>
                <li>45160 Olivet</li>
              </ul>
            </div>
          </div>
        </div>

        <div class="location__item">
          <iframe
            class="max-w-full"
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2677.8118436286536!2d1.9204639158269958!3d47.84323837959376!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x47e4e413906d1daf%3A0xd27f0e8c8d349d82!2s21%20Rue%20de%20Picardie%2C%2045160%20Olivet!5e0!3m2!1sfr!2sfr!4v1600634758327!5m2!1sfr!2sfr"
            width="600"
            height="250"
            frameborder="0"
            allowfullscreen=""
            aria-hidden="false"
            tabindex="0"
          ></iframe>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      title: 'CONTACT',
      contacts: [
        {
          name: 'Romain ESCURE',
          phone: '07 82 59 50 03',
          phoneLink: 'tel:+33782595003',
          mail: 'r.escure@corbet-com.fr',
          imgMail: '/static/contacts/r.escure.png'
        },
        {
          name: 'Amalia AIRES',
          phone: '02 38 63 14 01',
          phoneLink: 'tel:+33238631401',
          mail: 'a.aires@corbet-com.fr',
          imgMail: '/static/contacts/a.aires.png'
        },
        {
          name: 'Laura BARRE',
          phone: '02 38 63 44 40',
          phoneLink: 'tel:+33238634440',
          mail: 'contact@corbet-com.fr',
          imgMail: '/static/contacts/contact.png'
        }
      ]
    }
  }
}
</script>

<style lang="css" scoped>
li {
  position: relative;
}

ul {
  font-size: 4.8vw;
}

.content__wrapper--contact {
  padding: 2.5% 7% 5%;
}

.contact {
  display: flex;
  flex-direction: column;
  width: 100%;
  margin: 5% 0;
}

.contact__single {
  padding: 5% 0;
  border-bottom: 1px solid #707070;
}

.contact__single:last-child {
  border-bottom: none;
}

.contact-icon {
  position: absolute;
  width: 7vw;
  height: 7vw;
  top: 0;
  bottom: 0;
}

.location__item,
.locationInfos__item {
  flex-basis: 100%;
  margin: 0 0 8vw 0;
}

.locationInfos__item--full {
  flex-basis: 100%;
  margin-top: 1vw;
}

.contact__details {
  color: #5db99d;
  font-weight: bold;
  margin-left: 7vw;
}

.phone-icon {
  background-image: url(/static/phone-icon.png);
}

.mail-icon {
  background-image: url(/static/mail-icon.png);
}

.location-icon {
  max-width: 24vw;
  margin-right: 4%;
  border: 2px solid #707070;
  border-radius: 20px;
}

@media screen and (max-width: 768px) {
  .mail-link img {
    margin-left: 7vw;
    height: 4vw;
  }

  /*.mail-link--contact img {
  margin-left: 20vw;
  height: 4vw;
}*/
}

@media screen and (min-width: 768px) {
  ul {
    font-size: 0.94vw;
  }

  .content {
    margin-left: 30%;
  }

  .contact {
    flex-direction: row;
    flex-wrap: nowrap;
  }

  .contact__single {
    flex-grow: 0;
    border-right: 2px solid #707070;
    border-bottom: none;
    padding: 0 2% 0 1%;
    text-align: left !important;
  }

  .contact__single:last-child {
    border-right: none;
    padding-right: 0 !important;
  }

  .contact__single:first-child {
    padding: 0 2% 0 1%;
    border-left: 2px solid #707070;
  }

  .contact__list li,
  .locationInfos__item ul li {
    height: 1.8vw !important;
    display: flex;
    align-items: center;
  }

  .noIcon {
    margin-left: 2.5vw;
  }

  .contact-icon {
    position: absolute;
    width: 2.1vw;
    height: 2.1vw;
    margin: auto;
    top: 0;
    left: 0;
    bottom: 0;
  }
  .contact__details {
    margin-left: 2.5vw;
  }

  .contact__details--img {
    margin-left: 2.5vw;
    max-height: 0.8vw;
  }

  .location__item,
  .locationInfos__item {
    flex-basis: 50%;
    margin: 0 !important;
    text-align: left;
  }

  .locationInfos__item--full {
    flex-basis: 100%;
  }

  .location-icon {
    max-width: 5.5vw;
    margin-right: 4%;
    border: 2px solid #707070;
    border-radius: 20px;
  }
  .locationPlan {
    max-height: 15vw;
    margin: auto;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/Contact.vue